// extracted by mini-css-extract-plugin
export var quillEditor = "_ms-1";
export var variable = "_ms-0";